import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const NameStyles = styled(OnboardingPage)`
  --padding-start: 10px;
  --padding-end: 10px;

  .response {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  .start {
    color: transparent;
  }

  .finish {
    color: transparent;
    text-shadow: 0 0 0.3em rgb(0 0 0);
  }

  .finishMeet {
    color: rgba(0, 0, 0, 1);
    text-shadow: 0 0 0em rgba(0, 0, 0, 0);
  }
`;
